import routerOptions0 from "/Users/jonathan.leignier/Desktop/FC&AL FILE/Retailers/Git-Dentsu-clone v2/dentsu/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.1_db0@0.2.3_ioredis@5.4.2_lightning_30e81d2c116553d57190abbadd0c479d/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  linkActiveClass: "router-link-active",
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}